export default "__VITE_ASSET__CnbwMmbL__"